module.exports = __webpack_public_path__ + "img/imagem7.4dbe538d.svg";